export const isFormFilled = (filters, setMsgFilter) => {
    let requiredMsg = ["Informe "]

    if (!filters.cliente)
        requiredMsg.push("um Cliente")
    if (!filters.dataInicio && !filters.dataFim) {
        if (requiredMsg.length > 1)
            requiredMsg.push(", Data de Início e Data de Fim")
        else
            requiredMsg.push("Data de Início e Data de Fim")
    } else if (!filters.dataInicio && filters.dataFim) {
        if (requiredMsg.length > 1)
            requiredMsg.push(" e Data de Início")
        else
            requiredMsg.push("Data de Início")
    } else if (filters.dataInicio && !filters.dataFim) {
        if (requiredMsg.length > 1)
            requiredMsg.push(" e Data de Fim")
        else
            requiredMsg.push("Data de Fim")
    }

    if (requiredMsg.length > 1) {
        setMsgFilter(`${requiredMsg.join("")}`)
        return false
    } else {
        setMsgFilter("")
        return true
    }
}